import { Check, Loader2 } from "lucide-react";

export function SaveBar({ busy, disabled = false, onSave, summary }) {
  const { added = [], edited = [], removed = [], shipping = {} } = summary || {};
  const { assignmentSelections = 0, flagged = 0, includesDrafts = false } = shipping;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur border-t shadow-md pointer-events-none"
    >
      <div
        className="mx-auto max-w-5xl px-4 py-3 flex items-center justify-between gap-3 pointer-events-auto"
        style={{ paddingBottom: "max(env(safe-area-inset-bottom), 0px)" }}
      >
        <p className="text-sm text-gray-700">
          <span className="font-medium">{added.length}</span> new ·{" "}
          <span className="font-medium">{edited.length}</span> edited ·{" "}
          <span className="font-medium">{removed.length}</span> deleted
          <span className="mx-2 text-gray-400">|</span>
          shipping:{" "}
          <span className="font-medium">{assignmentSelections}</span> selections
          {flagged > 0 ? <> · <span className="font-medium">{flagged}</span> flags</> : null}
          {includesDrafts ? <> · <span className="font-medium">includes drafts</span></> : null}
        </p>
        <button
          disabled={busy || disabled}
          onClick={onSave}
          className="btn-primary rounded-xl flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
          title={disabled ? "Fix validation errors to save" : undefined}
        >
        {busy ? <Loader2 className="animate-spin h-4 w-4" /> : <Check size={16} />}
          Save All
        </button>
      </div>
    </div>
  );
}
